import React from "react"
import { useTranslation } from "react-i18next"
import { Box, styled } from "@mui/material"

import Button from "components/ui/Button"
import { colors } from "theme"

type Props = {
  action: "sign" | "promise"
  isSigned: boolean
  needSubscription: boolean
  onSign?: () => void
  onDontLike?: () => void
}

const PaymentScheduleActionsComponent = ({
  action,
  isSigned,
  needSubscription,
  onSign,
  onDontLike,
}: Props) => {
  const { t } = useTranslation()

  return (
    <Container>
      {!isSigned && (
        <>
          <Sign disabled={needSubscription} onClick={onSign}>
            {t(`features.payment_schedule.actions.${action}.title`)}
          </Sign>
          <Reject onClick={onDontLike}>
            {t("features.payment_schedule.actions.reject.title")}
          </Reject>
        </>
      )}
    </Container>
  )
}

export default PaymentScheduleActionsComponent

export const Container = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-evenly",
  width: "50%",
  margin: "0 auto",
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}))

const Sign = styled(Button)(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.common.white,
  borderRadius: "21px",
  width: "186px",
  zIndex: 1,
  [theme.breakpoints.down("md")]: {
    margin: "0 0 15px 0",
  },
}))

const Reject = styled(Button)(({ theme }) => ({
  background: colors.lightPersianGreen,
  color: theme.palette.primary.main,
  borderRadius: "21px",
  width: "186px",
  zIndex: 1,
}))
